<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1 style="display:inline-block"> Surveys in Firebase Database</h1>
    <button class="btn btn-primary" style="float:right" (click)="add()">Add</button>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Edit</th>
                <th>Name</th>
                <th>hasMultipleAnswers</th>
                <th>Question</th>
                <th>Options</th>
                <th>Delete</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of surveys | keyvalue">
                <td><i class="bi bi-pencil" style="font-size: 1.0em;color:blue" (click)="editSurvey(item.key,item.value)"></i> </td>
                <td>{{item.key}}</td>
                <td>{{toAny(item.value).hasMultipleAnswers}}</td>
                <td>{{toAny(item.value).question}}</td>
                <td>
                    <div *ngFor="let opt of toAny(item.value).options | keyvalue">
                        {{opt.key}}:{{toAny(opt.value).option}}

                    </div>
                </td>
                <td><i class="bi bi-trash" style="font-size: 1.0em;color:orange" (click)="removeSurvey(item.key)"></i></td>
            </tr>
        </tbody>
    </table>
    <!-- Modal Window ---------------------------------------------------------------------------->
    <div *ngIf="showModal" #testmodal class="cpmodal">
        <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
            <h5>Survey</h5>
            <sa-input-text [(text)]="survey.question" [title]="'question' "></sa-input-text>
            <div class="row">
                <div class="col-md-6">
                    <sa-input-boolean [(checked)]="survey.canChangeVote" [title]="'canChangeVote' "></sa-input-boolean>
                </div>
                <div class="col-md-6">
                    <sa-input-boolean [(checked)]="survey.hasMultipleAnswers" [title]="'hasMultipleAnswers' "></sa-input-boolean>
                </div>
            </div>
            <sa-input-text [(text)]="survey.image" [title]="'image' "></sa-input-text>
            <sa-input-text [(text)]="survey.description" [title]="'description' "></sa-input-text>
            <div style="border:solid gray 1px;padding:5px"> 
                <button class="btn-primary" (click)="addOption()">Add New Option</button>
                <div class="row">
                    <div class="col-md-4"> <sa-label [text]="'Id = '+option.id"></sa-label></div>
                    <div class="col-md-4"><sa-input-text [(text)]="option.option" [title]="'option' "></sa-input-text></div>
                    <div class="col-md-4"><sa-input-number [(text)]="option.seqNo" [title]="'seqNo' "></sa-input-number></div>
                </div>
            </div>
            <h5>Options</h5>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>SeqNo</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let option of survey.options">
                        <td class="link" (click)="selectOption(option)">{{option.id}}</td>
                        <td>{{option.option}}</td>
                        <td>{{option.seqNo}}</td>
                        <td><button class="btn btn-warning" (click)="deleteOption(option)">Delete</button></td>
                    </tr>
                </tbody>
            </table>

            <!-- {{survey | json}} -->

            <br>
            <button class="btn btn-primary" (click)="updateSurvey()">Update</button>

            <button class="btn btn-primary" style="float:right" (click)="showModal = false">Close Modal</button>
        </div>
    </div>
        <!-- Name Modal ---------------------------------------------------------------------------->
        <div *ngIf="showModalName" #testmodal class="cpmodal">
            <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
                <h5>Modal Name</h5>
                <sa-input-text [(text)]="surveyKey" [title]="'Name' "></sa-input-text>
                <button class="btn btn-primary" (click)="createSurvey()">Create Survey</button>    
                <button class="btn btn-primary" style="float:right" (click)="showModalName = false">Close Modal</button>
            </div>
        </div>
    {{surveys | json}}

</div>